<template>
  <div class="review-edit-form mb-2">
    <div class="button-group row mt-3">
      <div class="col-md-6">
        <button type="button" class="btn btn-cancel w-100" @click="cancelEdit">Cancel</button>
      </div>
      <div class="col-md-6">
        <button type="submit" class="btn btn-edit w-100" @click="submitEdit">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CancelContinueButton",
  methods: {
    submitEdit () {
      let app = this
      app.$emit('submitEditInfo')
    },
    cancelEdit () {
      let app = this
      app.$emit('cancelEditInfo')
    }
  }
}
</script>
<style src="@/assets/css/review_edit.css"></style>
<style scoped>
</style>